export const Colors = {
    orangeShade: '#D04C00',
    lightOrange: '#FAEFE0'
};